import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { isEmpty } from 'lodash-es';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-additional-details-input',
  templateUrl: './additional-details-input.component.html',
  styleUrls: ['./additional-details-input.component.scss'],
  imports: [FaIconComponent, FormsModule]
})
export class AdditionalDetailsInputComponent implements OnInit, OnChanges {
  @Input() id = 'notes';
  @Input() value: string;
  @Input() frozen: boolean;
  @Input() rows = 3;
  @Input() required = false;
  @Output() valueChange = new EventEmitter<string>();

  show = false;

  constructor() {}

  ngOnInit(): void {
    this.show = this.required || !this.isEmpty;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['required']) {
      this.show = this.required || !this.isEmpty;
    }
  }

  get isEmpty() {
    return isEmpty(this.value);
  }

  onAdditionalTextChange() {
    this.valueChange.emit(this.value);
  }

  onPlusClick() {
    this.show = true;
  }

  onMinusClick() {
    this.show = false;
  }
}
